import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="mx-auto flex min-h-screen flex-1 items-center justify-center bg-gray-50">
      <Outlet />
    </div>
  );
};

export default AuthLayout;
